import { Trip } from './../classes.js';

export function video__element(data, edit = false){
	let $content = '';
	let $img = '';
	let $gallery = '';
	let $gallery_images = '';
	let $as_label = '';
	let $as_input = '';
	let $as_hidden = '';
	let $wrapper = '';
	let caption = '';
	
	//use the media ID to get the correct media details
	if(data.c.media_id == '' || typeof(data.c.media_id) == 'undefined'){
		if(window.content){
			if(typeof(Content.media.files[data.c.media_id]) == 'undefined'){
				data.c.media_path = '/system/app/lib/img/placeholder.jpg';
				data.c.media_alt = '';
				data.c.media_caption = '';
			}
		}else{
			if(typeof(Trip.media.files[data.c.media_id]) == 'undefined'){
				data.c.media_path = '/system/app/lib/img/placeholder.jpg';
				data.c.media_alt = '';
				data.c.media_caption = '';
			}
		}
	}else{
		if(window.content){
			data.c.media_path = Content.media.files[data.c.media_id].path;
			data.c.media_alt = Content.media.files[data.c.media_id].alt;
			data.c.media_caption = Content.media.files[data.c.media_id].caption;
		}else{
			data.c.media_path = Trip.media.files[data.c.media_id].path;
			data.c.media_alt = Trip.media.files[data.c.media_id].alt;
			data.c.media_caption = Trip.media.files[data.c.media_id].caption;
		}
	}
	
	//create the trip title element // edit or read
	if(edit){
		$content = $('<div/>', {
			'class': `e editable editable--image media__size--${data.c.media_size} media__position--${data.c.media_position}`,
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		
		//image_path input/upload
		$wrapper = $('<div/>', {
			'class': 'form__row'
		});
		
		
		caption = (data.c.media_caption == '' || data.c.media_caption == null || data.c.media_caption == 'null') ? '' : `<figcaption>${data.c.media_caption}</figcaption>`;
		$img = `
			<figure>
				<img src="${data.c.media_path}" alt="${data.c.media_alt}">
				${caption}
			</figure>
		`;
		
		$as_input = `
			<div class="editable__image_controller">
				<div class="controller_group">
					<div class="media-position-btn ${(data.c.media_position == 'left') ? 'active' : ''}" data-position="left">
						<span class="material-symbols-outlined">format_image_left</span>
					</div>
					<div class="media-position-btn ${(data.c.media_position == 'center') ? 'active' : ''}" data-position="center">
						<span class="material-symbols-outlined">picture_in_picture_center</span>
					</div>
					<div class="media-position-btn ${(data.c.media_position == 'right') ? 'active' : ''}" data-position="right">
						<span class="material-symbols-outlined">format_image_right</span>
					</div>
				</div>
				<div class="controller_group">
					<div class="media-size-btn ${(data.c.media_size == 'small') ? 'active' : ''}" data-size="small">
						<span class="material-symbols-outlined">photo_size_select_small</span>
					</div>
					<div class="media-size-btn ${(data.c.media_size == 'medium') ? 'active' : ''}" data-size="medium">
						<span class="material-symbols-outlined">photo_size_select_large</span>
					</div>
					<div class="media-size-btn ${(data.c.media_size == 'full') ? 'active' : ''}" data-size="full">
						<span class="material-symbols-outlined">width_full</span>
					</div>
				</div>
				
				<button class="media_gallery--open btn btn--secondary btn--small" data-set=${data.c.media_id}>Media Library</button>
			</div>
		`;
		
		/**** Additional Images Support ****/
		$gallery = $('<div/>', {
			'class': 'image__gallery'
		});
		
		$gallery_images = $('<div/>', {
			'class': 'gallery_images'
		});
		
		if(data.c.media_gallery != '' && data.c.media_gallery != null && typeof(data.c.media_gallery) != 'undefined'){
			let gallery_images = data.c.media_gallery.split(",");
			
			for (const gallery_image of gallery_images) {
				let media_path = '';
				let media_alt = '';
				
				if(window.content){
					media_path = Content.media.files[gallery_image].path;
					media_alt = Content.media.files[gallery_image].alt;
				}else{
					media_path = Trip.media.files[gallery_image].path;
					media_alt = Trip.media.files[gallery_image].alt;
				}
				
				$gallery_images.append(`
					<div class="gallery_image" data-media="${gallery_image}">
						<figure>
							<img src="${media_path}" alt="${media_alt}" />
						</figure>
						<div class="gallery_image_menu">
							<span class="edit-gallery-image material-symbols-outlined">edit</span>
							<span class="drag-gallery-image material-symbols-outlined">drag_pan</span>
							<span class="delete-gallery-image material-symbols-outlined">delete</span>
						</div>
					</div>
				`);
			}
		}
		
		$gallery.append($gallery_images);
		
		$gallery.append(`
			<div class="flex-row">
			</div>
			<button class="media_gallery--add btn btn--secondary btn--small">
				<span class="material-symbols-outlined">add</span>
				Gallery Image
			</button>
		`);
		
		
		/**** Inputs ****/
		$as_hidden = `
			<input class="media_id" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_id]" value="${data.c.media_id}" />
			<input class="media_position" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_position]" value="${data.c.media_position}" />
			<input class="media_size" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_size]" value="${data.c.media_size}" />
			<input class="media_gallery" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_gallery]" value="${data.c.media_gallery}" />
		`;
		
		$wrapper.append($img, $gallery, $as_input, $as_hidden);
		$content.append($wrapper);
		
	}else{
		$content = $('<div/>', {
			'class': `e editor media__size--${data.c.media_size} media__position--${data.c.media_position} ${data.c.media_gallery != '' ? 'media__has_gallery' : ''}`,
			'data-el_id': data.id,
			'data-block_id': data.block_id
		});
		
		caption = (data.c.media_caption == '' || data.c.media_caption == null || data.c.media_caption == 'null') ? '' : `<figcaption>${data.c.media_caption}</figcaption>`;
		$img = `
			<figure>
				<img src="${data.c.media_path}" alt="${data.c.media_alt}">
				${caption}
			</figure>
		`;
		$content.html($img);
		
		/**** Additional Images Support ****/
		$gallery = $('<div/>', {
			'class': 'image__gallery'
		});
		
		$gallery_images = $('<div/>', {
			'class': 'gallery_images'
		});
		
		if(data.c.media_gallery != '' && data.c.media_gallery != null && typeof(data.c.media_gallery) != 'undefined'){
			let gallery_images = data.c.media_gallery.split(",");
			
			for (const gallery_image of gallery_images) {
				let media_path = '';
				let media_alt = '';
				
				if(window.content){
					if(typeof(Content.media.files[gallery_image]) != 'undefined'){
						media_path = Content.media.files[gallery_image].path;
						media_alt = Content.media.files[gallery_image].alt;
					}
				}else{
					if(typeof(Trip.media.files[gallery_image]) != 'undefined'){
						media_path = Trip.media.files[gallery_image].path;
						media_alt = Trip.media.files[gallery_image].alt;
					}
				}
				
					
				$gallery_images.append(`
					<div class="gallery_image">
						<figure>
							<img src="${media_path}" alt="${media_alt}" />
						</figure>
					</div>
				`);
			}
		}
		
		$gallery.append($gallery_images);
		$content.append($gallery);
		
		
		if(Trip.has_permission){
			$as_hidden = `
				<input class="media_id" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_id]" value="${data.c.media_id}" />
				<input class="media_position" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_position]" value="${data.c.media_position}" />
				<input class="media_size" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_size]" value="${data.c.media_size}" />
				<input class="media_gallery" type="hidden" name="b[${data.block_id}][e][${data.id}][c][media_gallery]" value="${data.c.media_gallery}" />
			`;
			$content.append($as_hidden);
		}
	}
	
	if(Trip.has_permission || Content.edit){
		$content.append(`<input class="element_order" type="hidden" name="b[${data.block_id}][e][${data.id}][order]" value="${data.order}" />`);
		$content.append(`<input class="element_priority" type="hidden" name="b[${data.block_id}][e][${data.id}][priority]" value="${data.priority}" />`);
		$content.append(`<input type="hidden" name="b[${data.block_id}][e][${data.id}][type]" value="image" />`);
	}
	return $content;
}